export const BASE64_BLUR_DATA =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mN8XQ8AAlsBbNpBhIAAAAAASUVORK5CYII=';

export const MEC_TITLE = '| MEC';

export const DEFAULT_PRISMIC_PAGES_CACHE_TIME = 21600;

export const DEFAULT_PLP_CACHE_TIME = '86400';

export const PRODUCTS = 'products';
export const PRODUITS = 'produits';

export const MEC_SELLER_NAME = 'MEC';

export const SELLER_SYSTEMS = {
  MEC: 'MEC',
  EDI_DROPSHIP: 'EDI_DROPSHIP',
  MARKETPLACER: 'MARKETPLACER',
} as const;

export type SellerSystem = (typeof SELLER_SYSTEMS)[keyof typeof SELLER_SYSTEMS];

export const MEC_SELLER_SYSTEM: SellerSystem = SELLER_SYSTEMS.MEC;
